import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { delay, take } from 'rxjs/operators';

import { getAssociationsByCandidatesIdsAndJobId } from '@collections/associations';
import {
  submitHiringManagerCandidateAction,
  submitBatchHiringManagerCandidateAction,
} from '@collections/hiring-manager-status';

export interface HiringManagerSubmitModalData {
  headerText?: string;
  subheaderText?: string;
  candidateId?: number;
  candidateIds?: number[];
  jobId?: number;
  isBatchOperation?: boolean;
}

@Component({
  selector: 'mojo-hiring-manager-submit-modal',
  templateUrl: './hiring-manager-submit-modal.component.html',
  styleUrls: ['./hiring-manager-submit-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HiringManagerSubmitModalComponent {
  commentFormControl: UntypedFormControl = this.fb.control(null);
  form = this.fb.group({
    comment: this.commentFormControl,
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HiringManagerSubmitModalData,
    private dialogRef: MatDialogRef<HiringManagerSubmitModalComponent>,
    private fb: UntypedFormBuilder,
    private store: Store<{}>,
  ) {}

  onSubmit() {
    this.store
      .select(getAssociationsByCandidatesIdsAndJobId, {
        candidateIds: !!this.data.isBatchOperation
          ? this.data.candidateIds
          : [this.data.candidateId],
        jobId: this.data.jobId,
      })
      .pipe(take(1), delay(1000))
      .subscribe((associations) => {
        if (!!this.data.isBatchOperation) {
          this.store.dispatch(
            submitBatchHiringManagerCandidateAction({
              jobId: this.data.jobId,
              associations,
              noteComment: this.commentFormControl.value,
            }),
          );
        } else {
          associations.forEach((association) => {
            this.store.dispatch(
              submitHiringManagerCandidateAction({
                jobId: this.data.jobId,
                candidateId: association.candidateId,
                associationId: association.id,
                noteComment: this.commentFormControl.value,
                isBatchOperation: false,
              }),
            );
          });
        }
      });

    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
